import { Injectable } from '@angular/core';
import { cacheable } from '@datorama/akita';
import { mapTo, tap } from 'rxjs/operators';
import { ApiService } from '../../../shared/services/core/api.service';
import { EntityNotificationGroupDto } from './models/entity-notification-group-dto.model';
import { EntityNotificationGroup } from './models/entity-notification-group.model';
import { NotificationManagementStore } from './notification-management.store';

@Injectable({ providedIn: 'root' })
export class NotificationManagementService {
  constructor(private notificationManagementStore: NotificationManagementStore, private api: ApiService) {}

  /**
   * Retrieve all of the notification mangement groups for user
   */
  fetchNotificationGroups() {
    const request$ = this.api.get<EntityNotificationGroup>('notificationsmanagement').pipe(
      tap((groups) => {
        this.notificationManagementStore.set(groups);
      })
    );
    return cacheable(this.notificationManagementStore, request$).pipe(mapTo(null));
  }

  /**
   * Post the update of the group to the api and update the store with response
   */
  updateGroup(groupDto: EntityNotificationGroupDto) {
    this.api
      .post<EntityNotificationGroupDto>('notificationsmanagement/updategroup', groupDto)
      .subscribe((group: EntityNotificationGroupDto) => {
        this.notificationManagementStore.update(group.NotificationGroupId, { Active: group.Active });
      });
  }
}
